// useGoogleDriveApi.ts
import { useFetch } from "./FetchTemplate";
import { IAttachment } from "../interfaces/Booking.interface";
import { useCallback } from "react";
import { stringOrDate } from "react-big-calendar";
export function useGoogleDriveApi() {
  const { postFile, getData, postData } = useFetch();

  const uploadToGoogleDrive = async (file?: File, name?: string, bookingId?: string, folderId?: string) => {
    const formData = new FormData();
    if (file) formData.append("file", file);
    if (name) formData.append("name", name);
    if (bookingId) formData.append("bookingId", bookingId);  
    if (folderId) formData.append("folderId", folderId);

    return postFile("/api/booking/uploadToDrive", formData);
  };

  const getVideosByBookingId = useCallback(async (bookingId: string) => {
    return getData<IAttachment[]>(`/api/booking/getVideos?bookingId=${encodeURIComponent(bookingId)}`);
  }, []);

  const getFilesByBookingId = useCallback(async (bookingId: string) => {
    return getData<IAttachment[]>(`/api/booking/getFiles?bookingId=${encodeURIComponent(bookingId)}`);
  },[]);

  const deleteAttachment = async (bookingId: string, driveId: stringOrDate) => {
    return postData("/api/booking/deleteAttachment", { bookingId, driveId });
  };

  return { uploadToGoogleDrive, getVideosByBookingId, getFilesByBookingId, deleteAttachment};
}
